export {
  createArray,
  sumArray,
  averageArray,
  uniqueArray,
  shuffleArray,
  chunkArray,
  omitFromArray,
  difference,
} from './arrays.ts';
